import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Thank_you.css";

const ThankYou = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const { employeeName, ticketId } = location.state || {};

    return (
        <div className="thankyou-page">
            {/* Decorative glow circles */}
            <span className="thankyou-glow thankyou-glow-1"></span>
            <span className="thankyou-glow thankyou-glow-2"></span>
            <span className="thankyou-glow thankyou-glow-3"></span>

            <div className="thankyou-container">
                <h1><span className="thankyou-emoji">🎉</span>Submitted!</h1>
                <p>
                    Thank you, <strong>{employeeName}</strong>! <br />
                    Your ticket has been submitted successfully.
                </p>
                <p>
                    <strong>Ticket ID:</strong> <span className="thankyou-chip">{ticketId}</span>
                </p>
                <p>You will receive updates via email shortly.</p>

                <button
                    className="thankyou-button"
                    onClick={() => navigate("/Tickets")}
                >
                    Raise Another Ticket
                </button>

                <div style={{ marginTop: 32, paddingTop: 20, borderTop: "1px solid #F1F5F9" }}>
                    <div style={{
                        fontFamily: "'Sora', sans-serif",
                        fontWeight: 800,
                        fontSize: 16,
                        color: "#0D1B2A"
                    }}>
                        Dolluz Corp<span style={{ color: "#E8520A" }}>.</span>
                    </div>
                    <div style={{
                        fontSize: 10,
                        color: "#94A3B8",
                        letterSpacing: 1.5,
                        textTransform: "uppercase",
                        marginTop: 2
                    }}>
                        dAssist
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ThankYou;
